module.exports = __webpack_public_path__ + "media/images/writer-offering-merit01-b5aa1300b212ba5c9c2166128403fe87.png";